import axios from "utils/axios";

export const getCities = (params) => {
  return axios.get("/cities", { params });
};